import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import IconButton from '@material-ui/core/IconButton';

//Icon
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';



class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
  	}
  }


	render() {
    if (this.props.open === true) {
      return (
  			<div
  				style={{
  					position: "fixed",
  				  top: "0",
  				  left: "0",
  				  height:"100%",
  				  width: "100%",
  				  margin: "0",
  				  padding: "0",
  				  zIndex: "5000",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
  				}}
  			>
          <div
            style={{
              maxWidth:'600px',
              margin:'auto',
              height:"100%",
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              position:'relative'
            }}
          >

            <video src={this.props.videoPlayUri} style={{maxWidth:'100%', maxHeight:'100%'}} controlsList="nodownload" onContextMenu={ (e)=> {e.preventDefault();} } autoPlay muted controls></video>

            <div style={{position:'absolute', top:0, left:0, width:'100%'}} align='center'>
              <span style={{backgroundColor: "rgba(0, 0, 0, 0.8)", padding:'5px',color:'#AAA',fontSize:'0.8em',}}>動画メールはアプリから送信できます</span>
            </div>

            <IconButton
              onClick={ () => this.props.close() }
              style={{
                position:'absolute', top:0, right:0
  						}}
            >
              <ClearRoundedIcon style={{fontSize:'2em', color:'#FFF'}} />
            </IconButton>
          </div>
  			</div>
  		)
    }
		else {
      return null;
    }
	}
}

const mapStateToProps = (state) => {
	return {
		lightbox: state.lightbox,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({

	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
